import { render, staticRenderFns } from "./festivos-boletin.vue?vue&type=template&id=31a805fc&scoped=true"
import script from "./festivos-boletin.vue?vue&type=script&lang=js"
export * from "./festivos-boletin.vue?vue&type=script&lang=js"
import style0 from "./festivos-boletin.vue?vue&type=style&index=0&id=31a805fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a805fc",
  null
  
)

export default component.exports